/**
 * MessageAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MessageAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19 3.1A2.9 2.9 0 0 1 21.9 6v12a2.9 2.9 0 0 1-2.9 2.9h-4.628l-1.736 1.736a.9.9 0 0 1-1.18.08l-.092-.08L9.627 20.9H5a2.9 2.9 0 0 1-2.895-2.73L2.1 18V6A2.9 2.9 0 0 1 5 3.1zm0 1.8H5A1.1 1.1 0 0 0 3.9 6v12A1.1 1.1 0 0 0 5 19.1h5a.9.9 0 0 1 .636.264L12 20.727l1.364-1.363a.9.9 0 0 1 .518-.256L14 19.1h5a1.1 1.1 0 0 0 1.1-1.1V6A1.1 1.1 0 0 0 19 4.9m-6.19 6.533.093.104c.33.417.33 1.01 0 1.426l-.09.1a1.15 1.15 0 1 1-.003-1.63m4 0 .093.104c.33.417.33 1.01 0 1.426l-.09.1a1.15 1.15 0 1 1-.003-1.63m-8 0 .093.104c.33.417.33 1.01 0 1.426l-.09.1a1.15 1.15 0 1 1-.003-1.63" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MessageAltIcon = makeIcon('MessageAltIcon', MessageAltIconSvg)
